import React from 'react';
import {View, Pressable} from 'react-native';
import moment from 'moment';

import Text from '../../elements/Text';

import makeStyles from './styles';
import {useTheme, useThemedStyles} from '../../../theme';
import {tID} from '../../../utils/TestIdHelper';
import {EditIcon} from '../../../utils/SvgIcons';
import CommonStyles from '../../../utils/CommonStyles';
import {useTimeFormat} from '../../../hooks/useTimeFormat';

const NoteCard = ({
  note,
  style,
  onPressEdit,
  onPressNote,
  listView = false,
  index,
  showDateTime = false,
}) => {
  const {colors} = useTheme();
  const styles = useThemedStyles(makeStyles);
  const timeFormat = useTimeFormat();

  const formatDateTime = (date) => {
    const momentDate = moment(date);
    const timeStr = timeFormat === '12'
      ? momentDate.format('hh:mm A')
      : momentDate.format('HH:mm');
    return `Added ${momentDate.format('MM-DD-YYYY')} - ${timeStr}`;
  };

  return (
    <Pressable
      testID={tID(`NoteCard-Pressable-Main${index}`)}
      onPress={onPressNote}
      style={[styles.container, style]}>
      <View style={styles.fullFlex}>
        <Text
          testID={tID(`NoteCard-Text-Title${index}`)}
          variation="Body1SemiBold"
          color={colors.textPrimary}>
          {note.title}
        </Text>
        <Text
          testID={tID(`NoteCard-Text-DateTime${index}`)}
          variation="Text1Regular"
          color={colors.textMuted}
          topMargin={5}>
          {showDateTime
            ? formatDateTime(note.createAt)
            : note.noteText}
        </Text>
      </View>
      {!listView && (
        <Pressable
          testID={tID(`NoteCard-Pressable-EditIcon${index}`)}
          onPress={onPressEdit}>
          <EditIcon width={20} height={20} style={CommonStyles.mr_10} />
        </Pressable>
      )}
    </Pressable>
  );
};

export default NoteCard;
